import { Layout } from "@/components/Layout";
import { Heart, Sprout, Users, Leaf } from "lucide-react";

const REVOLUT_URL = "https://revolut.me/nicoleinnocenti/pocket/2jHFbPee0r";

const WHY = [
  { icon: Sprout, title: "Recupero degli uliveti", text: "Ripuliamo e rigeneriamo i terreni colpiti dagli incendi e dall'abbandono." },
  { icon: Leaf, title: "Cura del territorio", text: "Interventi di prevenzione e manutenzione sul Monte Faeta e ad Asciano." },
  { icon: Users, title: "Comunità viva", text: "Attività, eventi e momenti che tengono unito il paese." },
];

export default function Dona() {
  return (
    <Layout>
      {/* HERO */}
      <section data-testid="dona-hero" className="relative bg-[#1f2d22] text-white overflow-hidden">
        <div className="pointer-events-none absolute -top-40 -right-24 w-[520px] h-[520px] rounded-full bg-[#C15C3D]/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-40 -left-24 w-[460px] h-[460px] rounded-full bg-[#6B8E3F]/20 blur-3xl" />
        <div className="relative max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 py-20 sm:py-24">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-1.5 mb-6">
            <Heart className="w-3.5 h-3.5 text-[#E8C9A0]" fill="currentColor" />
            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#E8C9A0]">Donazione libera</span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.02] tracking-tight max-w-3xl">
            Sostieni Per Asciano con <span className="italic font-light text-[#E8C9A0]">una donazione libera.</span>
          </h1>
          <p className="mt-6 text-base sm:text-lg text-white/85 leading-relaxed max-w-2xl">
            Ogni contributo, grande o piccolo, ci aiuta a prenderci cura del territorio. La donazione è libera e distinta dall'acquisto delle magliette.
          </p>
        </div>
      </section>

      {/* WHY */}
      <section className="py-14 sm:py-16 bg-white border-b border-[#E5E1D8]">
        <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 grid sm:grid-cols-3 gap-5">
          {WHY.map((w) => {
            const Icon = w.icon;
            return (
              <div key={w.title} className="rounded-3xl border-2 border-[#E5E1D8] bg-[#FBF9F6] p-6">
                <div className="w-11 h-11 rounded-2xl bg-[#2E4F3B]/10 flex items-center justify-center mb-4"><Icon className="w-5 h-5 text-[#2E4F3B]" /></div>
                <h3 className="font-display text-lg font-black text-[#1A1A1A]">{w.title}</h3>
                <p className="mt-1 text-sm text-[#5C5C5C] leading-relaxed">{w.text}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* DONATE */}
      <section data-testid="dona-form" className="py-16 sm:py-24 bg-[#FBF9F6]">
        <div className="max-w-xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="rounded-3xl border-2 border-[#E5E1D8] bg-white p-8 sm:p-10 text-center">
            <div className="w-14 h-14 rounded-2xl bg-[#C15C3D]/10 flex items-center justify-center mx-auto mb-5">
              <Heart className="w-7 h-7 text-[#C15C3D]" fill="currentColor" />
            </div>
            <h2 className="font-display text-2xl sm:text-3xl font-black text-[#1A1A1A]">Fai una donazione libera</h2>
            <p className="mt-3 text-sm sm:text-base text-[#5C5C5C] leading-relaxed">
              Sostieni le attività dell'associazione. Scegli tu l'importo direttamente su Revolut, in modo semplice e sicuro.
            </p>
            <a href={REVOLUT_URL} target="_blank" rel="noopener noreferrer" data-testid="dona-btn"
              className="mt-7 w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#C15C3D] hover:bg-[#a64830] text-white font-bold px-6 py-4 transition-colors shadow-lg">
              <Heart className="w-5 h-5" fill="currentColor" /> Dona
            </a>
            <p className="mt-3 text-xs text-[#5C5C5C] leading-relaxed">Ti porta su Revolut, dove scegli liberamente l'importo da donare.</p>
            <p className="mt-4 text-[11px] text-[#9a9a9a]">La donazione è libera e volontaria. Non costituisce ricevuta fiscale.</p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
